import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, GeoJSON, CircleMarker, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import { Plus, Minus } from 'lucide-react';
import { TOCOA } from '../lib/geo';
import 'leaflet/dist/leaflet.css';

const MapBehavior = ({ onPick, point, geometry, testId }) => {
  const map = useMapEvents({ click: (e) => onPick?.({ lat: e.latlng.lat, lng: e.latlng.lng }) });
  const controls = useRef(null);
  useEffect(() => {
    L.DomEvent.disableClickPropagation(controls.current);
    const observer = new ResizeObserver(() => map.invalidateSize({ pan: false }));
    observer.observe(map.getContainer());
    return () => observer.disconnect();
  }, [map]);
  const pointKey = point ? `${point.lat},${point.lng}` : '';
  const geometryKey = JSON.stringify(geometry);
  useEffect(() => {
    if (pointKey) map.panTo(pointKey.split(',').map(Number), { animate: false });
    else if (geometryKey && geometryKey !== 'null') {
      const bounds = L.geoJSON(JSON.parse(geometryKey)).getBounds();
      if (bounds.isValid()) map.fitBounds(bounds, { padding: [24, 24], maxZoom: 17 });
    }
  }, [map, pointKey, geometryKey]);
  return <div ref={controls} className="absolute top-3 right-3 z-[450] flex flex-col shadow-md">
    <button type="button" data-testid={`${testId}-zoom-in`} title="Acercar" onClick={() => map.zoomIn()} className="w-9 h-9 bg-white border rounded-t-lg flex items-center justify-center"><Plus size={18} /></button>
    <button type="button" data-testid={`${testId}-zoom-out`} title="Alejar" onClick={() => map.zoomOut()} className="w-9 h-9 bg-white border rounded-b-lg flex items-center justify-center"><Minus size={18} /></button>
  </div>;
};

export const AreaMap = ({ areas = [], point, onPick, geometry = null, selectedId, onAreaSelect, testId, children, className = '' }) => (
  <div data-testid={testId} className={`relative z-0 isolate h-[300px] min-w-0 overflow-hidden rounded-xl border border-gray-200 ${className}`}>
    <MapContainer center={point ? [point.lat, point.lng] : [TOCOA.lat, TOCOA.lng]} zoom={14} zoomControl={false} scrollWheelZoom={false} style={{ width: '100%', height: '100%' }}>
      <TileLayer url={process.env.REACT_APP_MAP_TILE_URL} attribution={`&copy; <a data-testid="${testId}-attribution" href="${process.env.REACT_APP_MAP_ATTRIBUTION_URL}" target="_blank" rel="noreferrer">OpenStreetMap contributors</a>`} maxZoom={19} />
      {areas.filter((a) => a.active && a.geometry).map((a) => <GeoJSON key={`${a.id}-${JSON.stringify(a.geometry)}-${selectedId === a.id}`} data={a.geometry} style={{ color: a.id === selectedId ? '#EE3B36' : '#0891B2', weight: 2, fillOpacity: a.id === selectedId ? 0.2 : 0.08 }} interactive={!!onAreaSelect} eventHandlers={onAreaSelect ? { click: () => onAreaSelect(a) } : {}} />)}
      {point && <CircleMarker center={[point.lat, point.lng]} radius={8} pathOptions={{ color: '#fff', weight: 3, fillColor: '#EE3B36', fillOpacity: 1 }} interactive={false} />}
      <MapBehavior onPick={onPick} point={point} geometry={geometry} testId={testId} />
      {children}
    </MapContainer>
  </div>
);